import '../style.scss'
import { RiCloseFill } from "react-icons/ri"
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, CustomContainer, Form, FormGroup } from "src/style"
import utility from "src/utils/utility"

export const TransferDetails: React.FC<any> = ({fundingInput, setFundingInput, next, close}) => {
    
    const handleAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
        let val = e.target.value.replace(/[,.]/g, '')
        if (!isNaN(Number(val))) {
            setFundingInput({...fundingInput, amount: val})
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Pay with Bank Transfer</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#667085'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <CustomContainer topMargin="2" minHeight="24">
                    <Form onSubmit={next}>
                        <FormGroup>
                            <label>Amount</label>
                            <input 
                                placeholder='Enter Amount' 
                                name='amount'
                                autoComplete='off'
                                value={fundingInput.amount ? utility.koboFormat(fundingInput.amount) : ''}
                                onChange={handleAmount}
                                required
                            />
                        </FormGroup>
                        <FlexRow justifyContent='flex-end'>
                            <Button
                                width='9.5'
                                height='4' radius='0.8'
                                bottomMargin='1' hoverColor='#0D968F'
                                hoverBgColor='#fff' borderColor='#0D968F'
                            >
                                Continue
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </FlexColumn>
        </>
    )
}